<template>
<router-link :to="`company/${id}`" :title="this.name">{{this.name}}</router-link>
</template>

<script>
export default {
    name: "MatrixCompanyLink",
    data () {
        return {
            id: 0,
            name: "",
        }
    },
    beforeMount () {
        const { id, name } = this.params.value
        this.id = id
        this.name = name ? name : ""
    },
}
</script>

<style scoped>
a {
    transition: font-weight 0.2s ease-in;
}

a:hover {
    font-weight: 600;
}
</style>